import React from 'react';

function CustomerAccessTab({
  allCustomers,
  assignedCustomers,
  selectedCustomerIds,
  setSelectedCustomerIds,
  handleCustomerAssign,
  handleCustomerRemove
}) {
  return (
    <div className="row">
      <div className="col-md-5">
        <h6>All Customers</h6>
        <select
          className="form-select"
          multiple
          size="10"
          value={selectedCustomerIds}
          onChange={(e) =>
            setSelectedCustomerIds(Array.from(e.target.selectedOptions).map(opt => opt.value))
          }
        >
          {allCustomers.map(customer => (
            <option key={customer.id} value={customer.id}>{customer.account_name}</option>
          ))}
        </select>
      </div>

      <div className="col-md-2 d-flex align-items-center justify-content-center">
        <button className="btn btn-primary" onClick={handleCustomerAssign}>&gt;&gt;</button>
      </div>

      <div className="col-md-5">
        <h6>Assigned Customers</h6>
        <ul className="list-group">
          {assignedCustomers.map(customer => (
            <li key={customer.id} className="list-group-item">
              {customer.account_name}
              <button
                className="btn btn-sm btn-danger float-end"
                onClick={() => handleCustomerRemove(customer.id)}
              >
                &lt;&lt;
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default CustomerAccessTab;
